import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { styles } from './UnauthorizedMessage.styles';

export function UnauthorizedMessage() {
  const slots = styles();

  const t = useTranslations();

  const handleClick = () => {
    utilEventAuthModal.open('review');
  };

  return (
    <div className={slots.base()}>
      <div className={slots.text()}>{t('review.form.unauthorizedMessage')}</div>
      <UiKitButtonBase
        className={slots.button()}
        onClick={handleClick}
      >
        {t('Login')}
      </UiKitButtonBase>
    </div>
  );
}
